import { Component } from 'react';
import { put } from 'helpers/apiHelpers';
import withStyles from '@material-ui/core/styles/withStyles';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { toast } from 'react-toastify';

import InfoModal from '../../../components/InfoModal/InfoModal';
import Button from '../../../components/CustomButtons/Button';
import BooleanView from '../../../components/DataGrid/ValueViews/BooleanView';

class PaymentNeedPayButton extends Component {
  state = {
    showModal: false,
    paymentNeedVerification: false,
  };

  componentDidMount() {
    this.setState({
      paymentNeedVerification: this.props.paymentNeedVerification,
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.paymentNeedVerification !== this.props.paymentNeedVerification
    ) {
      this.setState({
        paymentNeedVerification: this.props.paymentNeedVerification,
      });
    }
  }

  toggleModal = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  changeStatus = () => {
    this.toggleModal();
  };

  handleStatusChange = () => {
    const { t } = this.props;
    // eslint-disable-next-line no-console -- FIXME
    console.log('first');
    put(this.props.orderId, {
      paymentNeedVerification: !this.state.paymentNeedVerification,
    })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(() => {
        this.setState({
          paymentNeedVerification: !this.state.paymentNeedVerification,
        });
        toast.success(t('success.statusUpdated'));
      })
      // eslint-disable-next-line promise/prefer-await-to-then, promise/prefer-await-to-callbacks -- FIXME
      .catch(error => {
        // eslint-disable-next-line no-prototype-builtins -- FIXME
        if (error.hasOwnProperty('response')) {
          const {
            response: { data },
          } = error;
          // eslint-disable-next-line no-prototype-builtins -- FIXME
          if (data.hasOwnProperty('violations')) {
            toast.error(data.violations.map(el => el.message).join(' '));
          }
        }
      });

    if (this.state.showModal) {
      this.toggleModal();
    }
  };

  render() {
    const { t } = this.props;

    return (
      <>
        <div onClick={() => this.changeStatus()}>
          <BooleanView value={this.state.paymentNeedVerification} />
        </div>

        <InfoModal
          modalState={this.state.showModal}
          handleClose={() => this.toggleModal}
          modalContent={
            <>
              <p>{t('orders.modalPaymentNeedVerification.text')}</p>
              <div>
                <Button onClick={() => this.handleStatusChange()}>
                  {t('orders.modal.button.yes')}
                </Button>
                <Button onClick={this.toggleModal}>
                  {t('orders.modal.button.no')}
                </Button>
              </div>
            </>
          }
        />
      </>
    );
  }
}

const enhance = compose(withStyles(extendedFormsStyle), withTranslation());

export default enhance(PaymentNeedPayButton);
